import { css } from 'lit';

export default css`
  /* Component-Specific Measurements */
  --button-height: 3rem;            /* Button height */
  --button-width: 12rem;            /* Button width */ 
  --vertical-card-height: 500px;    /* Card height */
  --vertical-card-width: 350px;     /* Card width */
  --card-min-width: 200px;          /* Card minimum width */
  --horizontal-card-width: 100%;
  --horizontal-card-height: 200px;
  --header-height: 100px;           /* Header height */
  --input-text-height: 16px;        /* Input text height */
  --list-control-width: 1.25rem;    /* List control width */
  --menu-item-height: 50px;         /* Menu item height */
  --menu-width: 250px;              /* Menu width */
  --profile-avatar-size: 40px;      /* Avatar size */
  --task-panel-width: 400px;        /* Task panel width */
  --task-panel-hide: -400px;        /* Task panel hidden position */
`;
